/** Platform logos — used everywhere except the marketing landing page (Navigation.tsx). */
export const PLATFORM_LOGO_SMALL = 'txl_lite_small.webp';
export const PLATFORM_LOGO_BIG = 'txl_lite_big.webp';

export const getPlatformLogoSrc = (
  size: 'small' | 'big',
  basename = process.env.PUBLIC_URL || ''
) =>
  `${basename}/images/${size === 'small' ? PLATFORM_LOGO_SMALL : PLATFORM_LOGO_BIG}`;
